import { z } from 'zod';
import { recordingPinSchema } from '../api/macroPackage/authoringPrimitives';
import { rawPackageUploadGrantTokenSchema } from '../api/macroPackage/uploadAuthorization';

export const MACRO_PACKAGE_UPLOAD_ACTION = 'macroPackageUpload';
const identity = {
  requestId: z.string().uuid(), hostId: z.string().min(1).max(128),
  campaignId: z.string().min(1).max(128), pin: recordingPinSchema,
};

/** The authenticated admin peer owns this transfer; Start additionally requires a writable-campaign grant. */
export const macroPackageUploadRequestSchema = z.discriminatedUnion('command', [
  z.object({ ...identity, command: z.literal('start'), uploadGrantToken: rawPackageUploadGrantTokenSchema }).strict(),
  z.object({ ...identity, command: z.literal('status') }).strict(),
]);
export const macroPackageUploadReplySchema = z.discriminatedUnion('state', [
  z.object({ ...identity, state: z.literal('uploading') }).strict(),
  z.object({ ...identity, state: z.literal('verifying') }).strict(),
  z.object({ ...identity, state: z.literal('complete') }).strict(),
  z.object({ ...identity, state: z.literal('failed'), error: z.string().regex(/^[a-z0-9_]{1,128}$/) }).strict(),
]);
export type MacroPackageUploadRequest = z.infer<typeof macroPackageUploadRequestSchema>;
export type MacroPackageUploadReply = z.infer<typeof macroPackageUploadReplySchema>;
export type PlaycastMacroPackageUploadMessages =
  | { target: 'system'; action: 'macroPackageUpload'; isReply: false; message: MacroPackageUploadRequest }
  | { target: 'system'; action: 'macroPackageUpload'; isReply: true; message: MacroPackageUploadReply };
